// Central site content — Cegu Masaj Salonu Özlüce

export const CONTACT = {
    phone: "0224 413 40 37",
    phoneRaw: "+902244134037",
    whatsapp: "0536 219 22 98",
    whatsappRaw: "905362192298",
    address: "Bursa · Nilüfer · Özlüce",
    fullAddress: "Batı Palas, Özlüce Mah., Nilüfer / Bursa",
    mapLink: "https://maps.app.goo.gl/CyJfAWVaknNwV3dU8",
    hours: "Her gün · 10:00 — 24:00",
    hoursShort: "10:00 — 24:00",
    instagram: "#",
    logoUrl:
        "https://customer-assets-agu9un31.emergentagent.net/job_a7e68c08-9ab2-4fa1-b8cd-6f79c74db534/artifacts/4ipzd8v6_ChatGPT%20Image%203%20A%C4%9Fu%202026%2021_52_12.png",
};

export const WHATSAPP_MSG = encodeURIComponent(
    "Merhaba, Cegu Masaj Salonu için randevu almak istiyorum."
);
export const WHATSAPP_URL = `https://wa.me/${CONTACT.whatsappRaw}?text=${WHATSAPP_MSG}`;
export const TEL_URL = `tel:${CONTACT.phoneRaw}`;

export const IMAGES = {
    exterior:
        "https://customer-assets-agu9un31.emergentagent.net/job_a7e68c08-9ab2-4fa1-b8cd-6f79c74db534/artifacts/pl5j1wo4_Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202026-08-04%20225146.png",
    tigerRoom:
        "https://customer-assets-agu9un31.emergentagent.net/job_a7e68c08-9ab2-4fa1-b8cd-6f79c74db534/artifacts/1em7gjwf_2020-06-02.jpg",
    redRoom:
        "https://customer-assets-agu9un31.emergentagent.net/job_a7e68c08-9ab2-4fa1-b8cd-6f79c74db534/artifacts/i8ceysii_2022-05-18.jpg",
    greenRoom:
        "https://customer-assets-agu9un31.emergentagent.net/job_a7e68c08-9ab2-4fa1-b8cd-6f79c74db534/artifacts/zognbcho_20221008_135530.jpg",
    // Hero — hot stones with orchid on back (elegant, distinctive)
    heroSpa:
        "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=1600&q=85&auto=format&fit=crop",
    // Service-specific curated images (verified to match each service)
    klasik:
        "https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&q=80&auto=format&fit=crop", // hands on shoulders
    yagli:
        "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&q=80&auto=format&fit=crop", // therapist pouring oil
    medikal:
        "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=1200&q=80&auto=format&fit=crop", // B&W deep back massage
    thai:
        "https://customer-assets-v7afamib.emergentagent.net/job_cegu-masaj-bursa/artifacts/xlm4wws5_images%20%282%29.jpg", // gerçek Thai masajı stretching
    sultan:
        "https://customer-assets-v7afamib.emergentagent.net/job_cegu-masaj-bursa/artifacts/w53wq090_sultan-4-el-masaji-one-cikan.jpg", // 4-el sultan masajı
    jakuzi:
        "https://customer-assets-v7afamib.emergentagent.net/job_cegu-masaj-bursa/artifacts/fz3xjmy5_images%20%281%29.jpg", // gerçek jakuzi salon fotoğrafı
    // detail / gallery
    stones:
        "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=1200&q=80&auto=format&fit=crop",
    oil: "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=1200&q=80&auto=format&fit=crop", // oil bottle dripping
    candles:
        "https://images.unsplash.com/photo-1620733723572-11c53f73a416?w=1200&q=80&auto=format&fit=crop", // candles + diffuser
    hands: "https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=1200&q=80&auto=format&fit=crop",
    towel: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1200&q=80&auto=format&fit=crop",
    petal: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1200&q=80&auto=format&fit=crop",
    detail: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&q=80&auto=format&fit=crop",
    lobby:
        "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=1200&q=80&auto=format&fit=crop",
    room: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=1600&q=85&auto=format&fit=crop",
    corridor:
        "https://customer-assets-v7afamib.emergentagent.net/job_cegu-masaj-bursa/artifacts/tchyqdz0_5D419C70-BFEC-421D-8F4A-C55EBE2A4286.jpeg",
};

// 6 core services (shown on home) — additional SEO pages still exist
export const SERVICES = [
    {
        slug: "klasik-masaj",
        title: "Klasik Masaj",
        seoTitle: "Bursa Klasik Masaj",
        duration: "60 dk",
        short:
            "Bedendeki gerginlikleri çözen, dolaşımı canlandıran temel wellness uygulaması. Uzman terapistlerimiz size uygun yoğunlukta uygular.",
        long: "Klasik masaj; bedendeki gerilim noktalarını gevşetmek, dolaşımı canlandırmak ve zihni sakinleştirmek için uygulanan temel bir masaj uygulamasıdır. Uzman terapistlerimiz farklı yoğunluklarda kayma, ovma ve derin baskı tekniklerini bir araya getirerek size uygun bir uygulama tasarlar.",
        keywords: [
            "Bursa klasik masaj",
            "Özlüce klasik masaj",
            "Nilüfer masaj salonu",
        ],
        image: "klasik",
    },
    {
        slug: "yagli-masaj",
        title: "Yağlı Masaj",
        seoTitle: "Bursa Yağlı Masaj",
        duration: "60 dk",
        short:
            "Aromatik yağlarla bedeni besleyen, akıcı ve gevşetici bir masaj. Kas yorgunluğunu hafifletir, cildi yumuşatır.",
        long: "Doğal aromaterapi yağları ile uygulanan yağlı masaj, ciltte ipeksi bir kayma sağlar; kaslardaki yorgunluğu azaltırken duyusal bir dinlenme sunar. Lavanta, tatlı badem ve zencefil yağlarımızdan dilediğinizi seçebilirsiniz.",
        keywords: [
            "Bursa yağlı masaj",
            "Özlüce yağlı masaj",
            "aromaterapi masaj Bursa",
        ],
        image: "yagli",
    },
    {
        slug: "medikal-masaj",
        title: "Medikal Masaj",
        seoTitle: "Bursa Medikal Masaj",
        duration: "50 dk",
        short:
            "Kronik ağrılara ve postür sorunlarına yönelik terapötik bir masaj uygulaması. Boyun, sırt ve bel bölgelerinde etkilidir.",
        long: "Boyun, sırt ve bel bölgesindeki kronik gerginliklere yönelik uygulanan medikal masaj; tetik nokta terapisi, myofasyal gevşetme ve derin doku teknikleriyle bedenin dengesini yeniden kurar.",
        keywords: [
            "Bursa medikal masaj",
            "Nilüfer medikal masaj",
            "sırt boyun masajı Bursa",
        ],
        image: "medikal",
    },
    {
        slug: "thai-masaji",
        title: "Thai Masajı",
        seoTitle: "Bursa Thai Masajı",
        duration: "75 dk",
        short:
            "Uzakdoğu geleneğine dayanan, esneme ve akupresür içeren bütünsel bir masaj uygulaması. Bedeni esnetir, enerji verir.",
        long: "Thai masajı; pasif yoga pozisyonları, akupresür ve ritmik baskı hareketleriyle uygulanan bütünsel bir uygulamadır. Bedeninizi esnetir, enerji hatlarını açar ve derin bir hafiflik hissi bırakır.",
        keywords: [
            "Bursa Thai masajı",
            "Özlüce Thai masaj",
            "Uzakdoğu masajı Bursa",
        ],
        image: "thai",
    },
    {
        slug: "sultan-masaji",
        title: "Sultan Masajı",
        seoTitle: "Bursa Sultan Masajı",
        duration: "90 dk",
        short:
            "Hamam kesesi, köpük banyosu ve yağlı vücut masajını birleştiren imza uygulamamız. Baştan sona yenileyici.",
        long: "Sultan masajı; Cegu imzalı çok aşamalı bir wellness uygulamasıdır. Klasik hamam kesesi, zeytinyağı bazlı köpük banyosu ve ardından uygulanan yağlı vücut masajı ile bedeninizi baştan sona yenileyen bir deneyimdir.",
        keywords: [
            "Bursa Sultan masajı",
            "Özlüce Sultan masaj",
            "hamam köpük masajı Bursa",
        ],
        image: "sultan",
    },
    {
        slug: "jakuzi",
        title: "Jakuzi",
        seoTitle: "Bursa Jakuzi & SPA",
        duration: "30 dk",
        short:
            "Isıtılmış termal su ve mineral köpük eşliğinde kasları gevşetici bir dinlenme seansı. Aromaterapi mumları eşlik eder.",
        long: "Masaj uygulamanızı tamamlayacak jakuzi seansı; ısıtılmış termal suyun içinde kasları gevşetir, dolaşımı hızlandırır ve dinlenme sağlar. Aromaterapi mumları ve müzik eşliğinde sunulur.",
        keywords: ["Bursa jakuzi", "Özlüce SPA", "Bursa wellness"],
        image: "jakuzi",
    },
    // extra SEO pages
    {
        slug: "aromaterapi",
        title: "Aromaterapi",
        seoTitle: "Bursa Aromaterapi Masajı",
        duration: "60 dk",
        short: "Uçucu yağlarla uygulanan holistik masaj.",
        long: "Aromaterapi masajı; lavanta, okaliptüs, ylang-ylang gibi bitkisel uçucu yağların bedene ve zihne etkisinden yararlanan holistik bir uygulamadır. Stresin izlerini siler, uyku kalitenizi artırır.",
        keywords: ["Bursa aromaterapi", "aromaterapi masaj Bursa"],
        image: "oil",
        hiddenFromGrid: true,
    },
    {
        slug: "refleksoloji",
        title: "Refleksoloji",
        seoTitle: "Bursa Refleksoloji",
        duration: "45 dk",
        short: "Ayak tabanı ve avuç içi refleks noktalarına uygulanan masaj.",
        long: "Refleksoloji; ayak tabanı, avuç içi ve kulaklardaki refleks noktalarına uygulanan baskı tekniklerini içeren geleneksel bir uygulamadır. Organların enerji akışını dengeler, yorgunluğu azaltır.",
        keywords: ["Bursa refleksoloji", "ayak masajı Bursa"],
        image: "petal",
        hiddenFromGrid: true,
    },
];

export const FAQ = [
    {
        q: "Bir masaj seansı ne kadar sürüyor?",
        a: "Seans süreleri seçtiğiniz uygulamaya göre değişir; 30 dakikalık jakuzi seansından 90 dakikalık sultan masajına kadar farklı süreler sunuyoruz.",
    },
    {
        q: "Randevu almam gerekiyor mu?",
        a: "Konforunuz için önceden randevu almanızı öneriyoruz. WhatsApp hattımızdan birkaç saniye içinde randevu oluşturabilirsiniz.",
    },
    {
        q: "Hijyen standartlarınız neler?",
        a: "Her seans öncesi ve sonrasında oda, terlik, havlu ve masaj masası tamamen değiştirilir; steril tekstil ve tıbbi düzeyde temizlik protokolü uygulanır.",
    },
    {
        q: "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
        a: "Nakit, kredi kartı ve mobil ödeme yöntemlerini kabul ediyoruz.",
    },
    {
        q: "Salon nerede? Nilüfer / Özlüce'de ulaşım nasıl?",
        a: "Salonumuz Bursa Nilüfer, Özlüce Mahallesi'nde Batı Palas içerisinde yer alır. Otopark alanımız mevcuttur.",
    },
];

export const REVIEWS = [
    {
        name: "Ahmet Y.",
        date: "Geçen ay",
        text:
            "Bursa'da bu kadar profesyonel bir masaj deneyimi bulmak zor. Hijyen ve terapist kalitesi çok iyi.",
        rating: 5,
    },
    {
        name: "Selin K.",
        date: "3 hafta önce",
        text:
            "Sultan masajı çok başarılıydı. Baştan sona kadar detaylara özenilmiş, tavsiye ederim.",
        rating: 5,
    },
    {
        name: "Mert D.",
        date: "1 ay önce",
        text:
            "Salonun atmosferi çok güzel. Medikal masaj sırt ağrımı 2 seansta rahatlattı.",
        rating: 5,
    },
    {
        name: "Deniz A.",
        date: "2 ay önce",
        text:
            "Özlüce'de yaşıyorum, ulaştığım en iyi salon. WhatsApp'tan randevu almak çok pratik.",
        rating: 5,
    },
    {
        name: "Emre T.",
        date: "3 ay önce",
        text:
            "Thai masajı beklediğimden çok daha etkileyiciydi. Terapist bilgili ve profesyonel.",
        rating: 5,
    },
    {
        name: "Ayşe C.",
        date: "4 ay önce",
        text:
            "Yağlı masaj sonrası kendimi çok dinlenmiş hissettim. Personel ilgili, ortam hijyenik.",
        rating: 5,
    },
];

export const FEATURES = [
    {
        title: "Uzman Terapistler",
        text: "Sertifikalı ve deneyimli ekiple çalışıyoruz.",
    },
    {
        title: "Hijyenik Ortam",
        text: "Her seansta yenilenen tekstil ve steril temizlik.",
    },
    {
        title: "Konforlu Salon",
        text: "Akustik yalıtımlı, klimalı özel odalar.",
    },
    {
        title: "Hızlı Randevu",
        text: "WhatsApp üzerinden dakikalar içinde randevu.",
    },
];
